import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Radio, Typography,
  Box,
} from '@mui/material';

import { 
  AccountGroupWithAccess,
  DatasetShareAccessLevel,
} from 'companion-app-components/flux/account-groups/accountGroupsTypes';

type Props = {
  accountGroups: AccountGroupWithAccess[]
  onAccessLevelChange: (id: string, selectedAccess: DatasetShareAccessLevel) => void;
};

const AccountGroupsShare: React.FC<Props> = ({ accountGroups, onAccessLevelChange }) => {

  const accessOptions: DatasetShareAccessLevel[] = ['NONE', 'READ', 'WRITE'];  

  return (
    <>
      <Typography variant="subtitle2" sx={{ pb: 2, mt: 2 }}> Assign Entity Permissions </Typography>
      <Box
        sx={({ palette }) => ({
          backgroundColor: palette.background.info,
          p: 1,
          borderRadius: 2,
          minWidth: 450,
        })}
      >
        <TableContainer 
          component={Paper} 
          elevation={0} 
          sx={{ 
            '&.MuiPaper-root': { 
              padding: 0,
              backgroundColor: 'inherit',
            },
          }}
        >
          <Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: 0 }}>
            <colgroup>
              <col style={{ width: '48%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '16%' }} />
              <col style={{ width: '16%' }} />
            </colgroup>
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderBottom: 'none', p: 0 }}>
                  <Typography variant="subtitle2">
                    Entity
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ borderBottom: 'none', p: 0 }}>
                  <Typography variant="subtitle2">
                    None
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ borderBottom: 'none', p: 0 }}>
                  <Typography variant="subtitle2">
                    View-Only
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ borderBottom: 'none', p: 0 }}>
                  <Typography variant="subtitle2">
                    View & Edit
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {accountGroups.map((accountGroup) => (
                <TableRow 
                  key={accountGroup.id}
                >
                  <TableCell sx={{ borderBottom: 'none', p: 0 }}>{accountGroup.name}</TableCell>
                  {accessOptions.map((accessOption) => (
                    <TableCell align="center" key={accessOption} sx={{ borderBottom: 'none', p: 0 }}>
                      <Radio
                        checked={accountGroup.permission === accessOption}
                        onChange={() => onAccessLevelChange(accountGroup.id, accessOption)}
                        value={accessOption}
                        name={`access-${accountGroup.id}`}
                        color="primary"
                        size="small"
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default AccountGroupsShare;
